import { mapQueryToPaginationProps, usePagination } from '@fourthwall/components'
import type { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'

import type { ChargesHistoryDataItem, TransactionStatus } from '../Billing.types'
import { useChargesQuery } from '../queries/useChargesQuery'
import { getChargeMethod } from '../utils/getChargeMethod'
import { getChargeType } from '../utils/getChargeType'

type ChargesStatusData = Awaited<
  ReturnType<typeof PaymentApiClient.getShopCharges>
>['data']['charges'][number]['status']

export const CHARGE_STATUS: Record<ChargesStatusData, TransactionStatus> = {
  PENDING: 'PROCESSING',
  INITIALIZED: 'PROCESSING',
  SUCCESSFUL: 'PAID',
  FAILED: 'FAILED',
}

type UseRecentChargesOptions = {
  enabled: boolean
}

export const useChargesHistory = ({ enabled }: UseRecentChargesOptions) => {
  const [currentPage, setCurrentPage] = usePagination()
  const { chargesQuery } = useChargesQuery([{ size: 6, page: currentPage - 1 }], {
    enabled,
    keepPreviousData: true,
  })

  const data: ChargesHistoryDataItem[] =
    chargesQuery.data?.charges.map(
      ({ id, createdAt, amount, reason, paymentMethodDetails, status }) => ({
        id,
        date: createdAt,
        amount,
        type: getChargeType(reason),
        method: getChargeMethod(paymentMethodDetails),
        status: CHARGE_STATUS[status],
      }),
    ) || []

  const pagination = mapQueryToPaginationProps(chargesQuery, currentPage, setCurrentPage)

  return {
    data,
    isLoading: chargesQuery.isLoading,
    pagination,
  }
}
